import { AppAttributes } from "../model/AppModel";
import useBackboneContext from "../provider/useBackboneContext";
import useBaseModelChange from "./useBaseModelChange";

const useAppModelChange = (list: Array<keyof AppAttributes> | "change") => {
  const { app } = useBackboneContext();
  return useBaseModelChange(list, app);
};

export default useAppModelChange;
